export const formatAddressWithAddress2 = (address: string, streetAddressTwo?: string): string => {
  if (streetAddressTwo) {
    const addressParts = address.split(',');

    return `${addressParts[0]}, ${streetAddressTwo}, ${addressParts.slice(1).join(', ')}`;
  }

  return address;
};
